/**
 * Storage Config API Client
 *
 * Frontend wrapper for storage path configuration CRUD operations
 * Used for managing archive/library/TX mezzanine/VOD delivery paths
 */

import axios from '@/axios'

export default {
  /**
   * Get all storage configs for current organization
   */
  async getAll() {
    try {
      const response = await axios.get('/api/storage-config')
      return response.data
    } catch (error) {
      console.error('Get storage configs error:', error)
      throw error
    }
  },

  /**
   * Get single storage config by ID
   */
  async getById(id) {
    try {
      const response = await axios.get(`/api/storage-config/${id}`)
      return response.data
    } catch (error) {
      console.error('Get storage config error:', error)
      throw error
    }
  },

  /**
   * Create new storage config
   */
  async create(data) {
    try {
      const response = await axios.post('/api/storage-config', data)
      return response.data
    } catch (error) {
      console.error('Create storage config error:', error)
      throw error
    }
  },

  /**
   * Update existing storage config
   */
  async update(id, data) {
    try {
      const response = await axios.put(`/api/storage-config/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Update storage config error:', error)
      throw error
    }
  },

  /**
   * Delete storage config
   */
  async delete(id) {
    try {
      const response = await axios.delete(`/api/storage-config/${id}`)
      return response.data
    } catch (error) {
      console.error('Delete storage config error:', error)
      throw error
    }
  },

  /**
   * Test storage config connection
   * @param {number} id - Storage config ID to test
   */
  async testConnection(id) {
    try {
      const response = await axios.post('/api/storage-config/test', { id })
      return response.data
    } catch (error) {
      console.error('Test connection error:', error)
      throw error
    }
  },

  /**
   * Browse files in a storage configuration
   * @param {number} id - Storage config ID
   * @param {string} prefix - Optional path prefix
   * @param {string} extensions - Optional comma-separated extensions (e.g., 'mxf,mp4,mov')
   * @returns {Promise<{files: Array, totalFound: number, truncated: boolean}>}
   */
  async browse(id, prefix = '', extensions = '') {
    try {
      const params = new URLSearchParams()
      if (prefix) params.append('prefix', prefix)
      if (extensions) params.append('extensions', extensions)

      const queryString = params.toString()
      const url = `/api/storage-config/${id}/browse${queryString ? '?' + queryString : ''}`

      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error('Browse storage error:', error)
      throw error
    }
  }
}
